import React from 'react'
import { Outlet } from 'react-router-dom'

import { CategoriesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CategoriesSection } from './CategoriesSection'

const CategoryLayout: React.FC = () => {
  const { loading, data, error } = useQuery(CategoriesDocument, {
    variables: { showInHomepage: true },
  })
  const templates = data?.processes.templates || []

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      header={{
        title: i18n.t('processes.breadcrumbs.workflows_title'),
      }}
      variant="wide"
    >
      <CategoriesSection
        templates={templates}
        trainingsPolicies={{
          checkTrainingsModule:
            data?.trainings._policies.sidebarSeeMyTrainingsTopLevelItem.can ?? false,
          checkTrainingsPermission:
            data?.trainings._policies.trainingsAccessManagementSpace.can ?? false,
        }}
      />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default CategoryLayout
